import { FormItem, SelectInput } from '@framework/form';
import { yup } from '@framework/validation';
import React from 'react';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { WidgetType } from '../../../Widget';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent';
import {
  DateWidgetFormats,
  DefaultWidgetDateFormat,
  type IDateWidget,
} from './IDateWidget';

export const dateInputConfigValidator = CommonInputWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Date).required(),
  dateFormat: yup
    .string()
    .oneOf(
      DateWidgetFormats.map(f => f.key),
      'Formato data non valido',
    )
    .notRequired()
    .nullable()
    .label('Formato data'),
}) satisfies yup.ObjectSchema<IDateWidget>;

export interface IDateWidgetConfigComponentProps
  extends IWidgetComponentProps<IDateWidget> {}

export function DateWidgetConfigComponent(
  props: IDateWidgetConfigComponentProps,
) {
  return (
    <>
      <CommonConfigComponent {...props} />
      <FormItem name="dateFormat" label="Formato data">
        <SelectInput
          name="dateFormat"
          options={DateWidgetFormats.map(f => ({
            value: f.key,
            label: f.label,
          }))}
          placeholder={DefaultWidgetDateFormat.label}
          allowClear
        />
      </FormItem>
    </>
  );
}
